export class PincodeModel {
    id:number;
    cityId:number;
    stateId:number;
    countryId:number;
    status:string;
    pincode:string;
}
